export interface ChurnRun {
  id: string;
  params: { months_back?: number; inactive_days?: number };
  model: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  created_by: string;
  total_users: number;
  processed_users: number;
  error: string | null;
  created_at: string;
  updated_at: string;
}

export interface ChurnRecord {
  id: string;
  user_id: number;
  user_email: string;
  churn_type: ChurnType;
  plan_at_churn: string;
  churn_month: string;
  churn_date: string;
  reason_submitted: boolean;
  final_chat_id: string | null;
  final_session_message_count: number;
  final_session_downvoted: boolean;
  days_from_last_message_to_churn: number | null;
  label_status: LabelStatus;
  session_summary: string | null;
  key_user_quotes: string[];
  task_category: string | null;
  final_user_signal: string | null;
  session_end_state: string | null;
}

export type ChurnType = 'paid_cancelled' | 'trial_expired' | 'free_inactive';

export type LabelStatus = 'pending' | 'labeled' | 'no_chat_history' | 'failed';

export const CHURN_TYPE_LABELS: Record<ChurnType, string> = {
  paid_cancelled: 'Paid — cancelled',
  trial_expired: 'Trial expired',
  free_inactive: 'Free — walked away',
};

export const FINAL_USER_SIGNAL_LABELS: Record<string, string> = {
  complained_about_quality: 'Complained — quality',
  complained_about_accuracy_or_hallucination:
    'Complained — accuracy / hallucination',
  complained_about_billing_or_limits: 'Complained — billing / limits',
  complained_about_other: 'Complained — other',
  neutral_leaving: 'Neutral leaving',
  positive_closing: 'Positive closing',
  no_final_user_message: 'No final user message',
  no_user_messages: 'No user messages',
  unclear: 'Unclear',
};

export const SESSION_END_STATE_LABELS: Record<string, string> = {
  user_got_what_they_needed: 'User got what they needed',
  assistant_underdelivered: 'Assistant underdelivered',
  user_stopped_mid_task: 'User stopped mid-task',
  blocked_by_error_or_limit: 'Blocked by error / limit',
  insufficient_signal: 'Insufficient signal',
};
